import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { canAccessRoute, getFirstAccessibleRoute } from '@domain/aplication/navigation-permissions';
import { AplicationService } from '@services/aplication/aplication.service';

export const permissionGuard: CanActivateFn = (_route, state) => {
    const aplicationService = inject(AplicationService);
    const router = inject(Router);

    const isAdmin = aplicationService.selectedAplicationIsAdmin();
    const hasImpersonate = aplicationService.selectedAplicationHasImpersonate();

    if (canAccessRoute(state.url, isAdmin, hasImpersonate)) {
        return true;
    }

    const fallback = getFirstAccessibleRoute(isAdmin, hasImpersonate);

    if (fallback) {
        router.navigate([fallback]);
    }

    return false;
};
